export enum ExplainScoreCriteriaDetailStepLayoutEnum {
  THUMBNAIL = 'thumbnail',
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
}
